<template>
  <div class="productWish">
    <template v-if="!isLoading">
      <template v-if="isLoadingProductsFired">
        <p v-if="!products || !products.length" class="color-inactive">{{ $t('YouNotHaveWishlist') }}</p>
      </template>
      <div class="productWishList">
        <div class="product"
             v-for="product in products"
             :key="product.id">
          <div class="wishlist--heart" @click="removeFromWishlist(product.id)">
            <div class="wishlist--heart--icon wishlist--heart--icon--fill"></div>
          </div>

          <a class="product__image" :href="product.get_absolute_url">
            <img class="product__image__main" :src="product.image" alt="product">
            <img class="product__image__second" :src="product.image_2" alt="product">
          </a>
          <div class="product__title">{{ product.title }}</div>
          <div class="product__content">
            <div class="product__content__price">
              <div v-if="product.sale_price" class="product__content__price__old">
                {{ product.unit_price }}
                <span>{{ $t('uah') }}</span>
              </div>
              <div class="product__content__price__new">
                {{ product.sale_price ? product.sale_price : product.unit_price }}
                <span>{{ $t('uah') }}</span>
              </div>
            </div>
            <div class="product__content__action">
              <a class="product__content__action__btn__bay" :href="product.get_absolute_url">
                {{ $t('Details') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMore" class="show-more" @click="getProducts()">
        <img :src="logoLoad" alt="load"/>
        {{ $t('ShowMore') }}
      </div>
    </template>
    <template v-else>
      <dashboard-local-preloader/>
    </template>
  </div>
</template>

<script>

import DashboardLocalPreloader from "@/components/LocalPreloader.vue";
import {actionTypes, getterTypes, mutationTypes} from "@/store/modules/products_wishlist";
import {mapGetters} from "vuex";

export default {
  name: 'DashboardProductWishlist',
  components: {
    DashboardLocalPreloader,
  },
  data(){
    return {
      logoLoad: require('@/assets/svg/arrow-clockwise.svg'),
      isLoadingProductsFired: false
    }
  },
  mounted() {
    this.$store.commit(mutationTypes.clearProducts)
    this.getProducts()
  },
  computed: {
    ...mapGetters({
      products: getterTypes.products,
      isLoading: getterTypes.isLoading,
      isMore: getterTypes.isMore,
    }),
  },
  methods: {
    getProducts(){
      this.$store.dispatch(actionTypes.getProducts).then(() => {
        this.isLoadingProductsFired = true
      })
    },
    removeFromWishlist(product_id){
      console.log("Remove from Wishlist:", product_id)
      this.$store.commit(mutationTypes.removeProduct, product_id)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .productWishList{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .wishlist--heart {
    padding: 10px;
    z-index: 1000;
    height: 35px;
    width: 35px;
    position: absolute;
    cursor: pointer;
    &--icon {
      width: 30px;
      height: 30px;
      background: #ffacb9;
      mask: url("../assets/svg/heart-straight.svg");
      &:hover{
        background: #ff738d;
      }
      &--fill{
        mask: url("../assets/svg/heart-straight-fill.svg") !important;
      }
    }
  }

  .product{
    display: flex;
    flex-flow: column;
    width: 250px;
    margin: 10px 20px 20px 10px;
    &:has(.product__image__main:hover) .product__image__second{
      opacity: 100%;
    }
    &__image{
      height: 250px;
      width: 250px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: opacity .2s ease-in-out;
      }
      &__main{
        position: relative;
        z-index: 1;
        &:hover{
          opacity: 0;
        }
      }
      &__second{
        opacity: 0;
        position: relative;
        margin-top: -278px;
      }
    }
    &__title{
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 1.2rem;
      min-height: 4rem;
    }
    &__content{
      display: flex;
      flex-flow: row;
      flex-wrap: nowrap;
      &__price{
        flex-grow: 1;
        display: flex;
        flex-flow: column;
        line-height: 1.2;
        align-content: center;
        padding-left: 10px;
        &__old{
          font-size: 0.9rem;
          margin-left: 0.2rem;
          margin-top: -0.8rem;
          position: absolute;
          span{
            font-size: 0.56rem;
            text-transform: uppercase;
          }
          &::after{
            content: '';
            width: calc(100% + 0.5rem);
            height: 2px;
            background-color: #da4453;
            transform: translateY(-50%);
            position: absolute;
            top: 50%;
            left: -0.25rem;
          }
        }
        &__new{
          font-size: 1.2rem;
          span{
            font-size: 0.8rem;
            text-transform: uppercase;
          }
        }
      }
      &__action{
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
        flex-wrap: wrap;
        align-content: center;
        &__btn{
          &__bay{
            width: auto;
            height: 30px;
            padding: 0 15px;
            font-size: 0.8rem;
            border-radius: 20px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #384967;
            border: 2px solid #384967;
            color: #FFFFFF !important;
            text-transform: uppercase;
            text-decoration: none;
          }
        }
      }
    }
  }

  .show-more{
    margin-top: 50px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e9e9e9;
    cursor: pointer;
    color: $fd;
    font-weight: 900;
    img{
      width: 35px;
      height: 35px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }
</style>